// components/Common/ConfirmModal.jsx
import React from "react";
import { FiAlertTriangle, FiX } from "react-icons/fi";
import "../../styles/confirm-modal.css";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  type = "danger", // danger, warning, info
}) => {
  if (!isOpen) return null;

  const getIconColor = () => {
    switch (type) {
      case "danger":
        return "#dc3545";
      case "warning":
        return "#ffc107";
      default:
        return "#2c7da0";
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={onClose}>
      <div
        className="confirm-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="confirm-modal-close" onClick={onClose}>
          <FiX />
        </button>

        <div className="confirm-modal-icon" style={{ color: getIconColor() }}>
          <FiAlertTriangle size={48} />
        </div>

        <h3 className="confirm-modal-title">{title}</h3>
        <p className="confirm-modal-message">{message}</p>

        <div className="confirm-modal-actions">
          <button className="confirm-modal-btn cancel" onClick={onClose}>
            {cancelText}
          </button>
          <button
            className={`confirm-modal-btn confirm ${type}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
